import axios from "axios";
import {
    ALL_BRANDS_REQUEST,
    ALL_BRANDS_SUCCESS,
    ALL_BRANDS_FAIL,
    CREATE_BRAND_REQUEST,
    CREATE_BRAND_SUCCESS,
    CREATE_BRAND_FAIL,
    CREATE_BRAND_RESET,
    UPDATE_BRAND_REQUEST,
    UPDATE_BRAND_SUCCESS,
    UPDATE_BRAND_FAIL,
    UPDATE_BRAND_RESET,
    DELETE_BRAND_REQUEST,
    DELETE_BRAND_SUCCESS,
    DELETE_BRAND_FAIL,
    DELETE_BRANDS_REQUEST,
    DELETE_BRANDS_SUCCESS,
    DELETE_BRANDS_FAIL,
    BRAND_PRODUCTS_REQUEST,
    BRAND_PRODUCTS_SUCCESS,
    BRAND_PRODUCTS_FAIL,
    BRAND_DETAILS_REQUEST,
    BRAND_DETAILS_SUCCESS,
    BRAND_DETAILS_FAIL,
    CLEAR_ERRORS,
} from "../constants/brandConstants";

// Get All Brands
export const getAllBrands = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_BRANDS_REQUEST });

        const { data } = await axios.get("/api/v1/brands");

        dispatch({
            type: ALL_BRANDS_SUCCESS,
            payload: data.brands,
        });

    } catch (error) {
        dispatch({
            type: ALL_BRANDS_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};

// Create Brand
export const createBrand = (brandData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_BRAND_REQUEST });

        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await axios.post("/api/v1/admin/brand/new", brandData, config);

        dispatch({
            type: CREATE_BRAND_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: CREATE_BRAND_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};

// Update Brand
export const updateBrand = (id, brandData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_BRAND_REQUEST });

        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await axios.put(`/api/v1/admin/brand/${id}`, brandData, config);

        dispatch({
            type: UPDATE_BRAND_SUCCESS,
            payload: data.success,
        });

    } catch (error) {
        dispatch({
            type: UPDATE_BRAND_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};


// Delete Brand
export const deleteBrand = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_BRAND_REQUEST });

        const { data } = await axios.delete(`/api/v1/admin/brand/${id}`);

        dispatch({
            type: DELETE_BRAND_SUCCESS,
            payload: data.success,
        });

    } catch (error) {
        dispatch({
            type: DELETE_BRAND_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};

// Delete Brands
export const deleteBrands = (ids) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_BRANDS_REQUEST });

        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await axios.post(`/api/v1/admin/brands/delete`, { ids }, config);

        dispatch({
            type: DELETE_BRANDS_SUCCESS,
            payload: data.success,
        });

    } catch (error) {
        dispatch({
            type: DELETE_BRANDS_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};

// Get Brand Products
export const getBrandProducts = (id) => async (dispatch) => {
    try {
        dispatch({ type: BRAND_PRODUCTS_REQUEST });

        const { data } = await axios.get(`/api/v1/brand/${id}`);

        dispatch({
            type: BRAND_PRODUCTS_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: BRAND_PRODUCTS_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};


// Clear All Errors
export const getBrandDetails = (id) => async (dispatch) => {
    try {
        dispatch({ type: BRAND_DETAILS_REQUEST });

        const { data } = await axios.get(`/api/v1/brand/${id}`);

        dispatch({
            type: BRAND_DETAILS_SUCCESS,
            payload: data.brand,
        });

    } catch (error) {
        dispatch({
            type: BRAND_DETAILS_FAIL,
            payload: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};


// Clear All Errors
export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
}
